import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Offcanvas, Accordion } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Sidebar.css';
import { Link, useLocation, useParams } from 'react-router-dom';
import config from '../../config/config';
import { useAccount } from 'wagmi';

const Sidebar = ({ special, clearModalData }) => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const [activeCard, setActiveCard] = useState(() => {
    return Number(localStorage.getItem('activeCard')) || 1;
  });
  const { address, isConnected } = useAccount();
  let walletAddress = isConnected ? address : null;

  const handleHomeClick = () => {
    document.body.classList.remove('dark-mode');
    document.body.classList.remove('light-mode');
  };

  const data = [
    {
      id: 1,
      title: 'AMM & Liquidity',
      icon: `images/dashboard/icon/home.svg`,
      link: `${config.baseUrl}dashboard/${walletAddress}/home`,
    },
    {
      id: 2,
      title: 'INFI Main',
      icon: `images/dashboard/icon/swap.svg`,
      children: [
        {
          id: 31,
          title: 'Staking',
          link: 'https://infimultichain.com/app/simplestaking',
          external: true,
        },
        {
          id: 32,
          title: 'SbSe Pools',
          link: 'https://infimultichain.com/app/dashboard',
          external: true,
        },
        { id: 33, title: 'Profits', link: `${config.baseUrl}profits` },
      ],
    },
    // {
    //   id: 2,
    //   link: 'https://infimultichain.com/ico/',
    //   external: true,
    //   title: 'INFI ICO',
    //   icon: 'images/dashboard/icon/ico.svg',
    // },

    {
      id: 4,
      title: 'Launchpad',
      icon: 'images/dashboard/icon/launchpad.svg',
      children: [
        { id: 41, title: 'Launchpad Home', link: `${config.baseUrl}launchpad` },
        {
          id: 42,
          title: "Active ICO's",
          link: `${config.baseUrl}launchpad#activepresale`,
        },
        { id: 43, title: 'Listed', link: `${config.baseUrl}launchpad#listed` },
      ],
    },
    {
      id: 5,
      title: 'Swap',
      icon: 'images/dashboard/icon/swap.svg',
      children: [
        { id: 51, title: 'SbSe Order Book (soon)', link: `${config.baseUrl}` },
        { id: 52, title: 'SbSe Instant (soon)', link: `${config.baseUrl}` },
        { id: 53, title: 'MarketPlace (soon)', link: `${config.baseUrl}` },
        {
          id: 54,
          title: 'INFI Hybrid eWallet (soon)',
          link: `${config.baseUrl}`,
        },
      ],
    },
  ];

  useEffect(() => {
    const currentPath = location.pathname
      .replace(config.baseUrl, '')
      .toLowerCase();
    const matched =
      data
        .flatMap((item) => item.children || [])
        .find((child) => currentPath.includes(child.link)) ||
      data.find((item) => currentPath.includes(item.link));
    if (matched) {
      setActiveCard(matched.id);
      localStorage.setItem('activeCard', matched.id);
    } else if (currentPath.includes('referral')) {
      setActiveCard(5);
      localStorage.setItem('activeCard', 5);
    }
  }, [location.pathname]);

  const handleCardClick = (id) => {
    setActiveCard(id);
    localStorage.setItem('activeCard', id);
    setShow(false);
  };

  return (
    <div className="sidebarBox position-relative bshadow">
      <div
        onClick={() => setShow(true)}
        className="d-lg-none"
        style={{
          position: 'absolute',
          top: '32px',
          left: '15px',
          width: '100px',
          cursor: 'pointer',
          zIndex: 1000,
        }}
      >
        ☰ <span>Menu</span>
      </div>

      <nav
        className="sidebar d-none d-lg-flex flex-column"
        style={{ padding: '15px' }}
      >
        <Link
          to={`${config.baseUrl}`}
          onClick={handleHomeClick}
          className="mb-4"
        >
          <img
            src={`${config.baseUrl}images/logos/logoMultichain.png`}
            style={{ width: 180, height: 40 }}
            alt="Logo"
            className="object-fit-contain"
          />
        </Link>

        <Accordion defaultActiveKey="" alwaysOpen className="flex-column gap-4">
          {data.map((item, index) => (
            <Accordion.Item
              key={item.id}
              eventKey={index.toString()}
              className="border-0 mb-4"
            >
              {item.children ? (
                <>
                  <Accordion.Header className="sidebar-tab dash-gradient">
                    <img
                      src={`${config.baseUrl}${item.icon}`}
                      alt=""
                      className="me-2"
                      width="20"
                      height="20"
                    />
                    {item.title}
                  </Accordion.Header>
                  <Accordion.Body className=" p-0">
                    {item.children.map((child) => (
                      <Link
                        key={child.id}
                        to={`${child.link}`}
                        onClick={() => handleCardClick(child.id)}
                        className={`d-block ${
                          activeCard === child.id
                            ? 'fw-bold text-decoration-underline'
                            : ''
                        }`}
                      >
                        {child.title}
                      </Link>
                    ))}
                  </Accordion.Body>
                </>
              ) : (
                <Link
                  to={`${item.link}`}
                  onClick={() => handleCardClick(item.id)}
                  className={`sidebar-tab dash-gradient d-flex align-items-center ${
                    activeCard === item.id ? 'active' : ''
                  }`}
                  style={{ padding: '16px 20px' }}
                >
                  <img
                    src={`${config.baseUrl}${item.icon}`}
                    alt=""
                    className="me-2"
                    width="20"
                    height="20"
                  />
                  {item.title}
                </Link>
              )}
            </Accordion.Item>
          ))}
        </Accordion>

        {special && (
          <div className="mt-4 mb-4">
            <Link
              to={`${config.baseUrl}referral`}
              onClick={() => handleCardClick(5)}
              className={`sidebar-tab dash-gradient py-3 px-4 ${
                activeCard === 5 ? 'active' : ''
              }`}
            >
              <img src="images/logout.svg" alt="" className="me-2" /> Referral
            </Link>
          </div>
        )}

        <footer
          className="position-absolute mb-0 start-0 end-0 w-100"
          style={{ bottom: '0%' }}
        >
          <div className="px-2 pb-2">
            <small className="text-light-grey x-small">
              <a href="mailto:support@infimultichain.com">
                support@infimultichain.com
              </a>
            </small>
          </div>
          <hr className="my-0" />
          <div className="footer-menu">
            <small className="text-light-grey x-small">
              © 2024 Infi Multichain Launchpad. All rights reserved.
            </small>
          </div>
        </footer>
      </nav>

      {/* Offcanvas for Mobile */}
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        className="d-lg-none slide-animation sidebarBox"
        style={{
          color: '#fff',
          height: '100vh',
          borderRadius: '0px 10px 10px 0px',
          overflow: 'auto',
        }}
      >
        <Offcanvas.Header closeButton>
          <Link to={`${config.baseUrl}dashboard`}>
            <img
              src={`${config.baseUrl}images/logos/logoMultichain.png`}
              style={{ width: 224, height: 53 }}
              alt="Logo"
            />
          </Link>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Accordion defaultActiveKey="" alwaysOpen className="flex-column">
            {data.map((item, index) => (
              <Accordion.Item
                key={item.id}
                eventKey={index.toString()}
                className="border-0 mb-4"
              >
                {item.children ? (
                  <>
                    <Accordion.Header className="sidebar-tab dash-gradient">
                      <img
                        src={`${config.baseUrl}${item.icon}`}
                        alt=""
                        className="me-2"
                        width="20"
                        height="20"
                      />
                      {item.title}
                    </Accordion.Header>
                    <Accordion.Body className="ps-4">
                      {item.children.map((child) => (
                        <Link
                          key={child.id}
                          // to={`${config.baseUrl}${child.link}`}
                          to={`${child.link}`}
                          onClick={() => handleCardClick(child.id)}
                          className={`d-block mb-2 ${
                            activeCard === child.id
                              ? 'fw-bold text-decoration-underline'
                              : ''
                          }`}
                        >
                          {child.title}
                        </Link>
                      ))}
                    </Accordion.Body>
                  </>
                ) : (
                  <Link
                    to={`${config.baseUrl}${item.link}`}
                    onClick={() => handleCardClick(item.id)}
                    className={`sidebar-tab dash-gradient py-3 px-4 d-flex align-items-center text-white ${
                      activeCard === item.id ? 'active' : ''
                    }`}
                  >
                    <img
                      src={`${config.baseUrl}${item.icon}`}
                      alt=""
                      className="me-2"
                      width="20"
                      height="20"
                    />
                    {item.title}
                  </Link>
                )}
              </Accordion.Item>
            ))}
          </Accordion>

          {special && (
            <div className="mt-4">
              <Link
                to={`${config.baseUrl}referral`}
                onClick={() => handleCardClick(5)}
                className={`sidebar-tab dash-gradient py-3 px-4 ${
                  activeCard === 5 ? 'active' : ''
                }`}
              >
                <img src="images/logout.svg" alt="" className="me-2" /> Referral
              </Link>
            </div>
          )}

          <div className="mt-4">
            <span>support@infimultichainlaunchpad.com</span>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Sidebar;
